import { StayPrimaryLandscape } from "@mui/icons-material";
import styled from "styled-components";

export const Container = styled.div`
  background-color: #fff;
  width: 100%;
  height: 100%;
`;

export const HeaderCadastro = styled.div`
  background-color: #08559f;
  width: 100%;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  border-radius: 0px 0px 30px 30px;
  box-shadow: 2px 2px 8px 0px #00000030;

  p {
    font-family: Montserrat, sans-serif;
    font-size: 17px;
    font-weight: 400px;
    color: #fff;
    margin-top: 20px;
  }

  div {
    display: flex;
    margin-top: 5px;
  }
`;
export const Step1 = styled.div`
  width: 40px;
  height: 5px;
  background-color: #fff;
  margin-left: 5px;
`;

export const Step2 = styled.div`
  width: 40px;
  height: 5px;
  border: 1px solid #fff;
  margin-left: 5px;
`;

export const BoxText = styled.div`
  text-align: center;
  padding: 30px;

  p {
    font-weight: 600;
  }
`;

export const Button = styled.div`
  width: 100%;
  padding: 5rem 1.875rem 0px 1.875rem;
`;

export const Icon = styled.div`
  position: absolute;
  left: 5px;
  top: 5px;
`;

export const Alert = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const UnderlineText = styled.p`
  text-decoration: underline;
  font-size: 14px;
  font-weight: 600;
  line-height: 14px;
  letter-spacing: 0.4px;
  margin-top: 5%;
  margin-bottom: 0px;
  cursor: pointer;
`;
export const TextDisabled = styled.p`
  font-size: 14px;
  font-weight: 600;
  line-height: 14px;
  letter-spacing: 0.4px;
  margin-top: 5%;
  margin-bottom: 0px;

  b {
    font-size: 14px;
    font-weight: 900;
    line-height: 14px;
    letter-spacing: 0.4px;
    margin-top: 5%;
    margin-bottom: 0px;
    cursor: pointer;
  }
`;
